import type { JobPostFilters } from "@av/apps/recruitment/ats-common/types";

export const jobsQueryKeys = {
  all: ["jobs"],
  detail: (jobPostId?: string) => [...jobsQueryKeys.all, "detail", jobPostId],
  list: (filters: JobPostFilters) =>
    [
      ...jobsQueryKeys.all,
      "list",
      {
        startDate: filters.startDate?.toISOString(),
        endDate: filters.endDate?.toISOString(),
        statuses: filters.statuses?.join(","),
        searchText: filters.searchText,
        city: filters.city?.join(","),
        compensation: filters.compensation?.toString(),
        locationType: filters.locationType?.toString(),
        jobPostId: filters.jobPostId,
      },
    ] as const,
  single: (jobPostId?: string) => [...jobsQueryKeys.all, "single", jobPostId],
};
